import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import RichText from '../components/RichText';
import { legalNoticePage } from '../data/siteContent';
import './About.css';

const LegalNotice = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <SEO
        page="mentions-legales"
        breadcrumb={[{ name: 'Accueil', path: '/' }, { name: 'Mentions légales', path: '/mentions-legales' }]}
      />
      <div className="service-page" data-testid="legal-notice-page">

        <section className="page-hero">
          <div className="container">
            <h1 className="page-title fade-in-up">{legalNoticePage.title}</h1>
            <p className="page-subtitle fade-in-up" style={{ animationDelay: '0.1s' }}>{legalNoticePage.subtitle}</p>
          </div>
        </section>

        <section className="section">
          <div className="container container-narrow">
            <div className="panel fade-in-up">
              <RichText blocks={legalNoticePage.blocks} />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default LegalNotice;
